module.exports = __webpack_public_path__ + "static/img/zxtp-details.7f28a60.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/image/zxtp-details.png
// module id = iVxk
// module chunks = 0